import { useGetPyqTopicList } from "../hooks/useGetPyqTopicList";
import { isEmpty } from "../../../../../../../custom_utilities/custom_useful_functions";
import images from "../../../../../../../utilities/images/images";
import "./TopicWiseData.scss";
import usePyqRedux from "../hooks/usePyqRedux";
import { useNavigation } from "../../../../../../../hooks/useNavigation";

const TopicWiseData = () => {
  const { data } = useGetPyqTopicList();
  const { setPyqTopicData, setPyqTopicSubject } = usePyqRedux();
  const { navigateTo } = useNavigation();

  const pyqSubjectTopics = (elem) => {
    setPyqTopicData({ subId: elem.sub_id, subName: elem.sub_name });
    setPyqTopicSubject({ subId: elem.sub_id, subName: elem.sub_name });
    navigateTo("/Pyq_subjectTopic");
  };
  return (
    <div className="topicWiseWrapper">
      {!isEmpty(data) && data?.length
        ? data.map((elem, index) => (
            <div
              key={index}
              className="topicBox"
              onClick={() => pyqSubjectTopics(elem)}
            >
              <div className="topicNameImg">
                <div className="img_wrp">
                  <img src={elem.icon1} alt="img" />
                </div>
                <h5>{elem.sub_name}</h5>
              </div>
              <div className="arrow">
                <img src={images.right_Ar} alt="arrow" />
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default TopicWiseData;
